import { PadiModal } from '../../helpers'
import PaymentAndCancellation from '../../helpers/PaymentsAndCancellation'
import './styles/cancellation-modal.scss'

export default function CancellationTermsModal({
  currency,
  isCustomCancellation,
  freeCancellationDays,
  customCancellationText,
  milestones,
  isOpen,
  onClose,
}) {
  return (
    <PadiModal isOpen={isOpen} onClose={onClose}>
      <PaymentAndCancellation
        onlyCancellation
        cancellationMilestones={milestones}
        isCustomCancellation={isCustomCancellation}
        customCancellationText={customCancellationText}
        currency={currency}
        freeCancellationDays={freeCancellationDays}
      />
    </PadiModal>
  )
}
